import React from 'react';
import BaseControl from '../common/BaseControl';
import store from '../../../store';
import StateProvider from '../control/StateProvider';
import EGKPIBox from './EGKPIBox';
import { planAnalyzeInfo, egAnalyzeInfo, crewAnalyzeInfo } from '../../../actions/analyze';
import { isCrewView, isEGView } from '../../../helpers/common';
import { BALER_CATEGORYIDS } from '../../../constants';
import "../../../../assets/scss/map-kpi-box.scss";

export default class MapKPIControl extends BaseControl {
    constructor(map, google) {
        super(map, google);
        this.controlBox = null;
        this.maxBoxLimit = 3;
        this.egListById = {};
        this.analyze = null;
        this.isBackward = true;
        this.storeUnsubscribe = null;

        this.subscribe = this.subscribe.bind(this);
        this.analyzeWindow = this.analyzeWindow.bind(this);
        this.remove = this.remove.bind(this);
        this.clear = this.clear.bind(this);
    };

    add(data) {
        if (!this.controlBox) this.controlBox = this.map.getControlBox(this.google.maps.ControlPosition.TOP_CENTER);
        if (this.controlBox.getControl(data.egId)) return;
        if (Object.keys(this.controlBox.getControls()).length === 0) this.egListById = {};
        if (Object.keys(this.egListById).length === 0) this.controlBox.removeAll();

        this.isBackward = true;
        if (!this.analyze) this.analyze = store.getState().analyze.analyzeParams;
        const crewId = data.crews && data.crews.length > 0 ? data.crews[data.crews.length - 1].crew_uuid : null;
        store.dispatch(egAnalyzeInfo(crewId, data.crews, data.egId, data.name, data.isTruck));

        const boxCount = Object.keys(this.egListById).length;
        if (boxCount >= this.maxBoxLimit) this.remove(Object.keys(this.egListById)[0], false);

        let kpiType = "nontruck";
        if (data.isTruck) kpiType = "truck";
        else if (BALER_CATEGORYIDS.indexOf(data.categoryId) >= 0) kpiType = "baler";

        this.egListById[data.egId] = data;
        this.controlBox.add({
            name: data.egId, className: "control-box",
            component:
                (<StateProvider store={store}>
                    <EGKPIBox egInfo={{ ...data, kpiType }} onClose={this.remove} />
                </StateProvider>)
        });
        this.subscribe();
    }

    remove(egIds, analyze = true) {
        if (!Array.isArray(egIds)) egIds = [egIds];
        for (const egId of egIds) {
            if (!this.controlBox || !this.controlBox.getControl(egId)) continue;
            if (this.egListById[egId]) delete this.egListById[egId];
            this.controlBox.remove(egId);
        }

        // Handle analyze info
        if (!analyze) return;
        const ids = Object.keys(this.egListById);
        const nextEGId = (ids.length > 0) ? ids[ids.length - 1] : null;
        this.analyzeWindow(nextEGId);
        this.subscribe();
    }

    analyzeWindow(egId) {
        let params = null;
        if (egId && this.isBackward)
            params = { ...this.egListById[egId] };
        else if (!egId && this.analyze) {
            params = { ...this.analyze, name: this.analyze.title };
            this.analyze = null;
        }

        if (!params) return;
        if (egId) {
            const crewId = params.crews && params.crews.length > 0 ? params.crews[params.crews.length - 1].crew_uuid : null;
            store.dispatch(egAnalyzeInfo(crewId, params.crews, egId, params.name, params.isTruck));
        }
        else if (isCrewView(params.view)) store.dispatch(crewAnalyzeInfo(params.crewId, params.name));
        else store.dispatch(planAnalyzeInfo());
    }

    subscribe() {
        const egCount = Object.keys(this.egListById).length;
        if (egCount === 1)
            this.storeUnsubscribe = store.subscribe(() => {
                const analyze = store.getState().analyze.analyzeParams;
                if (!isEGView(analyze.view)) {
                    this.analyze = analyze;
                    this.isBackward = false;
                }
            });
        else if (egCount === 0 && this.storeUnsubscribe)
            this.storeUnsubscribe();
    }

    clear() {
        for (let egId in this.egListById) this.remove(egId);
    }
}